export const apiType = {
  techno: 1,
  hobby: 2,
  value: 3,
};

export default {
  apiType,
};
